import { render, staticRenderFns } from "./NewPasswordConfirm.vue?vue&type=template&id=110becdc&scoped=true"
import script from "./NewPasswordConfirm.vue?vue&type=script&lang=js"
export * from "./NewPasswordConfirm.vue?vue&type=script&lang=js"
import style0 from "./NewPasswordConfirm.vue?vue&type=style&index=0&id=110becdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110becdc",
  null
  
)

export default component.exports